<section class="form mt-3" [formGroup]="form">
  <div class="row">
    <div class="col-md-6 mb-3 p-fluid">
      <label class="super-compos-label-input">{{ 'takeCharge.action' | translate }}</label>
      <p-dropdown
        formControlName="action"
        [options]="actionsLV"
        [filter]="true"
        [showClear]="true"
        [placeholder]="'takeCharge.selectActionType' | translate"
        styleClass="w-100"
        appendTo="body"
        autocomplete="new-password">
        <ng-template let-item pTemplate="selectedItem"
          ><span [ngStyle]="{ color: '#24344b' }">{{ item?.label }}</span></ng-template
        >
      </p-dropdown>
    </div>
    @if (right?.ficheCourrierDateLimitePriseEnChargeCachee === false) {
      <div class="col-md-6 mb-3 p-fluid">
        <label class="super-compos-label-input">{{ 'takeCharge.dueDate' | translate }}</label>
        <i-input [type]="'calendar'" [iInput]="{ options: { dateFormat: 'dd/mm/yy' } }" [control]="form.get('dateEcheance')"> </i-input>
      </div>
    }
    <div class="col-md-12 mb-3">
      <label class="super-compos-label-input">{{ 'takeCharge.comment' | translate }}</label>
      <textarea
        rows="5"
        cols="30"
        [placeholder]="'takeCharge.yourComment' | translate"
        formControlName="commentaires"
        class="super-compos-input-text form-control w-100"
        pInputTextarea></textarea>
    </div>
  </div>
  @if (right?.accesPriseEnChargeModeSimplifie === false) {
    <div class="row">
      <div class="col-md-6 p-fluid mb-3">
        <label class="super-compos-label-input"
          >{{ 'takeCharge.requestingService' | translate }}
          @if (isRequired) {
            <div class="d-inline-block">*</div>
          }
        </label>
        <p-treeSelect
          [options]="serviceParent"
          #treeSelectDemandeur
          selectionMode="single"
          [placeholder]="'pleaseSelectAService' | translate"
          appendTo="body"
          (onNodeSelect)="select($event, 'serviceDemandeur')"
          [emptyMessage]="'noResultFound' | translate"
          [filter]="true"
          [filterPlaceholder]="'global.filterPlaceholder' | translate"
          [filterBy]="'label'"
          [filterMode]="'strict'"
          [metaKeySelection]="false"></p-treeSelect>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="super-compos-label-input"
          >{{ 'takeCharge.mainService' | translate }}
          @if (isRequired) {
            <div class="d-inline-block">*</div>
          }
        </label>
        <p-treeSelect
          [options]="serviceParent"
          #treeSelectPrincipal
          selectionMode="single"
          [placeholder]="'pleaseSelectAService' | translate"
          appendTo="body"
          (onNodeSelect)="select($event, 'servicePrincipal')"
          [emptyMessage]="'noResultFound' | translate"
          [filter]="true"
          [filterPlaceholder]="'global.filterPlaceholder' | translate"
          [filterBy]="'label'"
          [filterMode]="'strict'"
          [metaKeySelection]="false"></p-treeSelect>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="super-compos-label-input">{{ 'takeCharge.additionalServices' | translate }}</label>
        <p-treeSelect
          #treeSelectMultiple
          [propagateSelectionUp]="false"
          [propagateSelectionDown]="true"
          selectionMode="checkbox"
          [options]="serviceParentMultiCheck"
          [placeholder]="'pleaseSelectOneOrMultipleServices' | translate"
          appendTo="body"
          (onNodeSelect)="selectMultiple()"
          (onNodeUnselect)="unselectMultiple($event)"
          [emptyMessage]="'noResultFound' | translate"
          class="pTreeMultiselect"
          [filter]="true"
          [filterPlaceholder]="'global.filterPlaceholder' | translate"
          [filterBy]="'label'"
          [filterMode]="'strict'"
          [metaKeySelection]="false">
        </p-treeSelect>
      </div>
      <div class="col-md-6 p-fluid mb-3">
        <label class="super-compos-label-input">{{ 'takeCharge.exclusiveCharge' | translate }}</label>
        <div>
          <p-checkbox
            (onChange)="enable = $event.checked"
            [readonly]="disabled"
            formControlName="priseEnChargeExclusive"
            binary="true"
            inputId="binary"></p-checkbox>
          <label for="binary" class="small-text ms-2 me-1">
            @if (enable) {
              {{ 'global.yes' | translate }}
            }
            @if (!enable) {
              {{ 'global.no' | translate }}
            }
          </label>
        </div>
      </div>
    </div>
  }
  <div class="d-flex justify-content-end">
    <i-button
      [text]="'back' | translate"
      styleClass="blue me-2"
      [pTooltip]="'back' | translate"
      tooltipZIndex="99999999"
      tooltipPosition="bottom"
      (click)="ref.close()">
    </i-button>
    <i-button (click)="submit()" [text]="'validate' | translate" styleClass="green"> </i-button>
  </div>
</section>
